<template>
  <div class="agreement-page">
    <div class="agreement-content">
      <h1 class="agreement-title">不乱价承诺同意书</h1>

      <p class="agreement-paragraph">
        本人已成为经销商会员，享有相关会员权益。为维护市场价格秩序、稳定统一售价，本人自愿作出如下承诺：
      </p>

      <div class="agreement-item">
        <div class="agreement-number"><strong>1.</strong></div>
        <div class="agreement-text">
          本人承诺在销售“爱了品牌·高奢丝滑.纤手养护装”产品时，严格遵守品牌销售价格不低于每盒<strong> 198 </strong>元标准，<strong>不低价乱价、不变相降价、不私自改价</strong>，不通过赠品、优惠券、返现等方式扰乱价格体系。
        </div>
      </div>

      <div class="agreement-item">
        <div class="agreement-number"><strong>2.</strong></div>
        <div class="agreement-text">
          本人接受品牌方的价格监督与核查，不泄露产品底价、定价策略等保密信息。
        </div>
      </div>

      <div class="agreement-item">
        <div class="agreement-number"><strong>3.</strong></div>
        <div class="agreement-text">
          若本人出现乱价行为，自愿<strong>赔偿全部损失</strong>，并<strong>自愿放弃所有会员权益</strong>，不作任何追偿与异议。
        </div>
      </div>

      <p class="agreement-paragraph agreement-footer-text">
        本人已认真阅读并完全理解以上内容，自愿遵守，郑重承诺。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoPriceDisorderAgreement'
}
</script>

<style scoped>
.agreement-page {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 20px 16px;
  background: #ffffff;
  color: #000000;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}

.agreement-content {
  width: 100%;
  box-sizing: border-box;
}

.agreement-title {
  margin: 0 0 48px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4;
}

.agreement-paragraph {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.8;
  text-align: justify;
}

.agreement-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.8;
}

.agreement-number {
  flex: 0 0 38px;
  padding-right: 10px;
  box-sizing: border-box;
  text-align: right;
  font-weight: 700;
}

.agreement-text {
  flex: 1;
  text-align: justify;
}

.agreement-text strong,
.agreement-number strong {
  font-weight: 700;
}

.agreement-footer-text {
  margin-top: 28px;
  margin-bottom: 0;
}
</style>